import validate from '../../../services/reduxValidate.js'

export default function(data) {

  return validate(data, {
    // Availability
    'freelance.date_available': { isoDate: true, presence: { allowEmpty: false } },
    'freelance.work_permit': { presence: { allowEmpty: false } },
    'freelance.situation': { presence: { allowEmpty: false } },
    'freelance.title': {
      presence: { allowEmpty: false },
      length: {
        maximum: 128,
        message: 'Le titre de votre fiche ne peut pas dépasser 128 caractères.'
      }
    },

    // Location and mobility
    'user.city': { presence: { allowEmpty: false } },
    'freelance.target_cities': { presence: { allowEmpty: false } },
    'freelance.relocation_long_fulltime': { inclusion: { within: [true, false] } },

    // Mission duration and format
    'freelance.part_time': { presence: { allowEmpty: false } },
  })
}
